import ResponsiveImage from '@monofront/design-system/components/ResponsiveImage';
import withSlice from '@screens/SlicesContainer/withSlice';
import React from 'react';
import { mapSingleFullWidth } from './mapImage';
import { IImageSingleFullWidth } from './types';
import { useMediaQuery } from '@monofront/business/hooks';

const SingleFullWidth: React.FC<IImageSingleFullWidth> = ({
  image,
  mobileImage,
}) => {
  if (!image) {
    return null;
  }

  const isMobile = useMediaQuery(800);
  const imageToDisplay = isMobile ? mobileImage ?? image : image;

  return (
    <div className="tw-w-full">
      <ResponsiveImage
        src={imageToDisplay.url}
        alt={imageToDisplay.alt}
        width={imageToDisplay.dimensions.width}
        height={imageToDisplay.dimensions.height}
      />
    </div>
  );
};

export default withSlice(SingleFullWidth, mapSingleFullWidth);
